import React, {
  FC,
  memo,
  useMemo,
  useState,
  useCallback,
}                              from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IOption }             from '@typings/components';
import { EAccountStatus }      from '@enums/accountManagement';
import { useFetchAccounts }    from '@modules/accountManagement/queries/accountQueries';
import { Loader }              from '@components/Loader/Loader';
import { DashboardPage }       from '@modules/dashboard/pages/DashboardPage';

export const Dashboard: FC<RouteComponentProps> = ({
  history: { push },
}) => {
  const [currentCuid, setCurrentCuid] = useState<string | null>(null);
  const [cuName, setCuName]           = useState<string | null>(null);

  // #region API INTEGRATION
  const { data: cuList } = useFetchAccounts('');
  // #endregion

  const accountsOptions = useMemo<IOption[]>(
    () => {
      if (!cuList) {
        return [];
      }

      const allAccountsOption: IOption = {
        value : '',
        label : 'All Accounts',
      };

      const cuOptions: IOption[] = cuList
        .filter(({ status }) => status === EAccountStatus.Active)
        .map(({ cuid, name }) => ({
          value : cuid,
          label : name,
        }));

      return [allAccountsOption, ...cuOptions];
    },
    [cuList],
  );

  const onCuidChange = useCallback(
    (option: IOption): void => {
      setCurrentCuid(option.value as string);
      setCuName(option.label as string);
    },
    [],
  );

  if (!cuList) {
    return <Loader />;
  }

  return (
    <DashboardPage
      cuid            = {currentCuid}
      cuName          = {cuName}
      accountsOptions = {accountsOptions}
      onCuidChange    = {onCuidChange}
      push            = {push}
    />
  );
};

export const DashboardContainer = memo(Dashboard);
